import { faker } from '@faker-js/faker'

import { asBuilder } from '../asBuilder'
import { QnaItem } from '../../contracts/service-offer'

export const getQnaItem = asBuilder((): QnaItem => {
  return {
    serviceOffer: {
      id: faker.number.int(),
      title: faker.string.uuid(),
    },
    question: {
      id: faker.number.int(),
      content: faker.string.uuid(),
      createdAt: faker.date.past().toISOString(),
    },
    answer: {
      id: faker.number.int(),
      questionId: faker.number.int(),
      content: faker.string.uuid(),
    },
  }
})
